// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__32cTV","content":"GlobalSearch_content__1l2pg"};